var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "full-view-header header-steps-wrapper flex flex-align-center flex-justify-center pd-2rem gap-1vw"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "header-steps-container m-w-100 gap-1vw w-auto bg-white rounded-button shadow-dark flex flex-align-center flex-justify-between p-l-2rem"
        },
        [
          _c(
            "p",
            {
              staticClass:
                "steps body-base flex flex-align-center flex-justify-center p-r-1rem"
            },
            [
              _c("span", { staticClass: "p-r-05rem" }, [
                _vm._v("STEP " + _vm._s(_vm.currentStep) + " OF 4:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "dot" }, [
                _c("span", { class: 1 <= _vm.currentStep ? "selected" : "" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "dot" }, [
                _c("span", { class: 2 <= _vm.currentStep ? "selected" : "" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "dot" }, [
                _c("span", { class: 3 <= _vm.currentStep ? "selected" : "" })
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "steps-text body-base flex flex-align-center gap-1vw desktop"
            },
            [
              _c("p", { class: 1 == _vm.currentStep ? "selected" : "" }, [
                _vm._v("Pick Gifts")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-arrow" }, [_vm._v(" > ")]),
              _vm._v(" "),
              _c("p", { class: 2 == _vm.currentStep ? "selected" : "" }, [
                _vm._v("Select Your Box")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-arrow" }, [_vm._v(" > ")]),
              _vm._v(" "),
              _c("p", { class: 3 == _vm.currentStep ? "selected" : "" }, [
                _vm._v("Write Your Card")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-arrow" }, [_vm._v(" > ")]),
              _vm._v(" "),
              _c("p", [_vm._v("Shipping")])
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "body-base mobile" }, [
            _vm._v(_vm._s(_vm.stepText))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "hb-btn primary slim p-l-unset p-r-unset",
              attrs: { disabled: !_vm.canNext },
              on: {
                click: function($event) {
                  return _vm.$emit("next-step")
                }
              }
            },
            [
              _c("span", { staticClass: "p-r-2rem p-l-2rem desktop" }, [
                _vm._v("Next Step >")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "p-r-1rem p-l-1rem mobile" }, [
                _vm._v("Next >")
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "dot" }, [_c("span")])
  }
]
render._withStripped = true

export { render, staticRenderFns }